<ng-content></ng-content>
@if (table.clickableRows) {
  <td class="chevron"><img src="./assets/svgs/chevron_forward.svg"></td>
}
